module.exports = __webpack_public_path__ + "img/logo_o9fhoi.b2cb7ea6.svg";